import { APIProvider, Circle, Map, Polyline} from '@vis.gl/react-google-maps';

import InteractiveMarker from '../components/map/interactiveMarker';
import './mapofus.css'
import { MARKERS } from './markers';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
const MAP_ID = process.env.REACT_APP_CUSTOM_MAP_ID

const UsPolyline = () => (
  <Polyline
    path={[
      {lat: 18.4915, lng: 73.8217},
      {lat: 10.0159, lng: 76.3419}
    ]}
    strokeColor={'#000'}
    strokeOpacity={0.8}
    strokeWeight={2}
  />
);

const GoogleMap = () => (
  <APIProvider apiKey={API_KEY}>
    <Map
      style={{width: '100vw', height: '100vh'}}
      defaultCenter={{lat: 18.5204, lng: 73.8567}}
      defaultZoom={5}
      gestureHandling='greedy'
      disableDefaultUI
      mapId={MAP_ID}
      colorScheme='light'
    >
      {MARKERS.map(marker => (
        <Circle
          key={marker.id}
          center={marker.position}
          radius={1000}
          fillColor={marker.borderColor}
          fillOpacity={0.3}
          strokeColor={marker.borderColor}
          strokeWeight={2}
        />
      ))}
      {MARKERS.map(marker => (
        <InteractiveMarker
          key={marker.id}
          position={marker.position}
          borderColor={marker.borderColor}
          popupContent={marker.popupContent}
        >
          {marker.markerContent}
        </InteractiveMarker>
      ))}
      {/* <Marker position={{lat: 18.4915, lng: 73.8217}} /> */}
      {/* <InfoWindow position={{ lat: 10.0159, lng: 76.3419}  }>
        The content of the info window is here.
      </InfoWindow> */}
      {/* <CustomizedMarker /> */}
      <UsPolyline />
    </Map>
  </APIProvider>
);

function MapOfUs() {
  return (
    <GoogleMap />
  );
}

export default MapOfUs;